export default "/assets/images/mila-air-specs-sm.png?cf33905f2d148ec21c45833a97569035";